<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  icon: {
    type: String, // SVG path data
    required: true,
  },
  color: {
    type: String,
    default: 'primary', // 'primary', 'success', 'warning', 'danger'
  },
});
</script>

<template>
  <div class="card h-100">
    <div class="card-body">
      <div class="d-flex align-items-center">
        <div class="flex-grow-1">
          <p class="text-sm mb-1 text-capitalize font-weight-bold">{{ title }}</p>
          <h5 class="font-weight-bolder mb-0">
            {{ value }}
          </h5>
        </div>
        <div class="icon icon-shape text-center rounded-circle" :class="`bg-gradient-${color}`">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-white" width="24px" height="24px">
            <path :d="icon" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon svg {
  width: 24px;
  height: 24px;
}
</style>
